// Start Pick n Mix Subscription bundle builder
document.addEventListener('theme:variant:change', function (event) {
  const detail = event.detail;
  const product = detail.product;
  const variant = detail.variant;

  if (variant && product) {
    const packSizeIndex = product.options.findIndex(option => option.toLowerCase() === 'pack size');
    if (packSizeIndex !== -1) {
      const packSizeValue = variant.options[packSizeIndex];
      handlePackSizeLogic(packSizeValue);
    }
  }
});

function handlePackSizeLogic(size) {
  const packSize = parseInt(size);
  const bundleSelectors = document.querySelectorAll('.bundle-builder__selector')

  if (!bundleSelectors.length) return

  bundleSelectors.forEach((selector, index) => {
    const isHidden = (index + 1) > packSize;
    const selectElement = selector.querySelector('select');

    selector.classList.toggle('hidden', isHidden);
    selectElement.disabled = isHidden;
  })
}
// End Pick n Mix Subscription bundle builder